import {
  ObtenerClasificaciones,
  ObtenerClasificacionPorCabecera,
  Cargando,
  Error,
} from "../Types/Clasificacion.type";

const INITIAL_STATE = {
  Clasificaciones: [],
  Clasificacion: {},
  Resultado: "",
  Mensaje: "",
  Cargando: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ObtenerClasificaciones:
      return {
        ...state,
        Clasificaciones: action.payload,
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    case ObtenerClasificacionPorCabecera:
      return {
        ...state,
        Clasificacion: action.payload[0] || {},
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    case Cargando:
      return {
        ...state,
        Resultado: "",
        Mensaje: "",
        Cargando: true,
      };
    case Error:
      return {
        ...state,
        Resultado: "E",
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    default:
      return state;
  }
};
